import React from 'react';
import { App, Button, Card, Col, DatePicker, Form, Input, Row, Select, Space } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { EnterprisePageHeader, WorkspaceLayout } from '@/components/enterprise';
import hrmsService from '@/services/hrms.service';
import { useEmployeeOptions } from './shared/useEmployeeOptions';

const LeaveBulkAbsencePage: React.FC = () => {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const { options: empOptions } = useEmployeeOptions();

  const save = async () => {
    try {
      const v = await form.validateFields();
      await hrmsService.bulkAbsence({
        employee_ids: v.employee_ids,
        leave_type: v.leave_type,
        from_date: v.dates[0].format('YYYY-MM-DD'),
        to_date: v.dates[1].format('YYYY-MM-DD'),
        reason: v.reason,
      });
      message.success('Bulk absence recorded');
      navigate('/hr/leaves');
    } catch {
      message.error('Bulk absence failed');
    }
  };

  return (
    <WorkspaceLayout
      header={
        <EnterprisePageHeader
          documentLabel="Bulk absence"
          subtitle="Create leave applications for multiple employees"
          primaryActions={
            <Space>
              <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/hr/leaves')}>
                Back
              </Button>
              <Button type="primary" icon={<SaveOutlined />} onClick={save}>
                Submit bulk
              </Button>
            </Space>
          }
        />
      }
    >
      <Form form={form} layout="vertical" initialValues={{ leave_type: 'Unpaid' }}>
        <Card title="Bulk absence">
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="employee_ids" label="Employees" rules={[{ required: true }]}>
                <Select mode="multiple" options={empOptions} showSearch optionFilterProp="label" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="leave_type" label="Leave type" rules={[{ required: true }]}>
                <Select
                  options={['Annual', 'Sick', 'Emergency', 'Unpaid'].map((v) => ({ value: v, label: v }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="dates" label="Period" rules={[{ required: true }]}>
                <DatePicker.RangePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="reason" label="Reason">
                <Input.TextArea rows={3} />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Form>
    </WorkspaceLayout>
  );
};

export default LeaveBulkAbsencePage;
